import axios from './axios-instance'

const BASEURL = '/cats?'

export default {
  async getCats() {
    return axios.get(BASEURL)
  },
}
